// 9fbef606107a605d69c0edbcd8029e5d
import { createSelector } from 'reselect';
import { ADDRESS_VERIFICATION_REDUCER_KEY } from '../../../../../constants/reducer.constants';

export const getAddressVerificationState = (state) => state?.[ADDRESS_VERIFICATION_REDUCER_KEY];

export const getUserAddress = createSelector(getAddressVerificationState, (state) =>
  state?.get('userAddress')
);

export const getSuggestedAddress = createSelector(getAddressVerificationState, (state) =>
  state?.get('suggestedAddress')
);

export const getVerificationResult = createSelector(getAddressVerificationState, (state) =>
  state?.get('resultType')
);

export const getVerificationResultCodes = createSelector(getAddressVerificationState, (state) =>
  state?.get('resultCodes')
);

export const getAfterPayPayload = createSelector(getAddressVerificationState, (state) =>
  state?.get('afterpayPayload')
);

export const getAddressLine2Error = createSelector(getAddressVerificationState, (state) =>
  state?.get('showAddressLine2Error')
);
